<template>
    <div>
        <maintwo
            :maintwoiconshow="maintwoiconshow"
            :maintwoforminfo="maintwoforminfo"
            :myinputoneisshow="maintwoforminfo.myinputoneisshow"
            :myinputone="maintwoforminfo.myinputone"
            :myselectleftisshow="maintwoforminfo.selectleftisshow"
            :myselectleft="maintwoforminfo.selectleft"
            :myinputonefullisshow="maintwoforminfo.myinputonefullisshow"
            :myinputonefull="maintwoforminfo.myinputonefull"
            v-on:getsearchinfo="getSeachinfoEvent"
            v-on:searchForm="searchFormEvent"
        >
            <template v-slot:searchModel>
                <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;color: #000;font-size: 14px;margin-right: 10px;">
                    <div><span>时间：</span></div>
                    <!-- type: monthrange||daterange -->
                    <datePicker
                        :SelectTimesCustom="back_SelectTimesCustom"
                        :Date_Disabled="true"
                        :Button_Change="{ chat: '请选择', type: 'monthrange', format: 'YYYY-MM' }"
                        :Out_Time="{ time_size: 31536000, erro_message: '选中的时间差不能超过 1 年' }"
                        @change-data="changeDataSearchEvent"
                    />
                </div>
            </template>
        </maintwo>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import maintwo from '@/components/Maintwo'

export default defineComponent({
    name: 'selectTwo',
    inject: ['reload'],
    props: ['ShowBackDatas'],
    watch: {
        ShowBackDatas: {
            handler(newVal) {
                this.maintwoforminfo.myinputonefull.input[1].id = newVal ? newVal.id : ''
                this.maintwoforminfo.myinputonefull.input[1].content = newVal ? newVal.content : ''
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            maintwoiconshow: false,
            maintwoforminfo: {
                selectleftisshow: true,
                selectleft: {
                    width: 'none',
                    divinterval: '', //框右侧距离
                    selectwidth: '100px',
                    selectinterval: '20px', //select右侧距离
                    select: [
                        {
                            selectisshow: true,
                            ismust: false,
                            title: '运营状态：',
                            placeholder: '全部',
                            name: 'run_type',
                            value: '',
                            options: [
                                {
                                    label: '全部',
                                    value: '0'
                                },
                                {
                                    label: '未出厂',
                                    value: '1'
                                },
                                {
                                    label: '运营中',
                                    value: '2'
                                },
                                {
                                    label: '已返厂',
                                    value: '3'
                                }
                            ]
                        }
                    ]
                },
                myinputonefullisshow: true, //筛选查询-自动建议下拉框
                myinputonefull: {
                    divinterval: '0', //框右侧距离
                    titlewidth: '74px', //标题宽度
                    inputwidth: '180px', //input宽度
                    inputinterval: '20px', //input右侧距离
                    input: [
                        {
                            ismust: false, //是否必填，true表示必填
                            title: '设备编号：',
                            placeholder: '请输入', //此name为键值
                            name: 'cid',
                            content: '',
                            id: '', //此id为给后台的id值
                            url: '/admin/getClientList',
                            inputval: { client: '' } //这里记录需要传的参数
                        },
                        {
                            ismust: false, //是否必填，true表示必填
                            title: '代理商：',
                            placeholder: '请输入',
                            name: 'agentid', //此name为键值
                            content: '',
                            id: '', //此id为给后台的id值
                            url: '/admin/shopUser/getShopList',
                            inputval: { name: '' } //这里记录需要传的参数
                        }
                    ]
                }
            },

            back_SelectTimesCustom: ''
        }
    },
    methods: {
        changeDataSearchEvent(data) {
            this.back_SelectTimesCustom = [data[0] * 1000, data[1] * 1000]
            this.$emit('getdatasearchinfo', data)
        },
        getSeachinfoEvent(data) {
            this.$emit('getsearchinfo', data)
        }
    },
    components: {
        maintwo
    }
})
</script>

<style scoped></style>
